import makeActionCreator from 'src/lib/makeActionCreator';
import { State } from 'src/redux/reducers/RootReducer';
import Debug from 'src/lib/Debug';
import {
  deleteFundraisingTransactionData,
  getFundraisingTransactionData,
  putFundraisingTransactionData,
} from 'src/apis/FundraisingTransactionAPI';
import { setAlert } from 'src/redux/actions/alertActions';
import { ALERT_TYPE } from 'src/constants/AlertType';
import { FundraisingTransaction } from 'src/models/FundraisingModel';

export const ADD_FUNDRAISING_TX = 'ADD_FUNDRAISING_TX';
export const REMOVE_FUNDRAISING_TX = 'REMOVE_FUNDRAISING_TX';

export const addFundraisingTransaction = makeActionCreator(ADD_FUNDRAISING_TX);
export const removeFundraisingTransaction = makeActionCreator(ADD_FUNDRAISING_TX);

export const getFundraisingTransactionAction: (id: string) => ThunkedAction<State> =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await getFundraisingTransactionData(organisation, id);
      if (response.success) {
        dispatch(addFundraisingTransaction({ id, transaction: response.data }));
      }
    } catch (e) {
      Debug.errorLog(e);
    }
  };

export const deleteFundraisingTransactionAction: (id: string) => ThunkedAction<State> =
  (id: string) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await deleteFundraisingTransactionData(organisation, id);
      if (response.success) {
        dispatch(removeFundraisingTransaction(id));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Transaction successfully deleted',
        }));
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error deleting transaction',
      }));
    } catch (e) {
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error deleting transaction',
      }));
      Debug.errorLog(e);
    }
  };

export const putFundraisingTransactionAction:
(fundraisingTransaction: FundraisingTransaction) => ThunkedAction<State> =
  (fundraisingTransaction: FundraisingTransaction) => async (dispatch: any, getState: any) => {
    const { id } = fundraisingTransaction;
    try {
      const organisation = getState().currentOrganisation.id;
      const response = await putFundraisingTransactionData(organisation, fundraisingTransaction);
      if (response.success) {
        dispatch(addFundraisingTransaction({ id, transaction: response.data }));
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: 'Transaction successfully deleted',
        }));
        return;
      }
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error deleting transaction',
      }));
    } catch (e) {
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: 'Error deleting transaction',
      }));
      Debug.errorLog(e);
    }
  };
